import { useEffect } from 'react';
import { sklepy } from '../data/dataSklepy';
import logo from '../images/logo.png';
import { BsTelephoneFill } from 'react-icons/bs';
const SklepyFirmowe = () => {
  useEffect(() => {
    document.title = 'Sklepy Firmowe - Kwiecińscy Zakład Mięsny';
    window.scrollTo(0, 0);
  }, []);
  return (
    <section className="sklepy-firmowe-section">
      <h2>SKLEPY FIRMOWE</h2>
      <div className="sklepy-firmowe-container container">
        {sklepy.map(({ id, miejscowosc, lokalizacja }) => {
          return (
            <article key={id}>
              <div className="sklep-miejscowosc">
                <img src={logo} alt="logo" />
                <div>
                  <h3>
                    Miejscowość: <span>{miejscowosc}</span>
                  </h3>
                  <p>Pon-Pt: 7:00 - 21:00</p>
                  <p>Sob: 7:00 - 14:00</p>
                </div>
              </div>
              <div className="sklep-lokalizacja">
                {lokalizacja.map((lok, index) => {
                  return (
                    <div key={index}>
                      <p className="address">Ul. {lok.ulica}</p>
                      <p className="flex justify-end items-center">
                        <BsTelephoneFill />
                        &nbsp; {lok.telefon}
                      </p>
                    </div>
                  );
                })}
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default SklepyFirmowe;
